import React from 'react';
import BlogCard from '../BlogCard/BlogCard';
import './BlogGrid.css';

const BlogGrid = ({ posts }) => {
  return (
    <div className="blog-grid">
      {posts.map((post, index) => (
        <BlogCard key={post.id} post={post} index={index} />
      ))}
    </div>
  );
};

export default BlogGrid;